import React, { useRef, useState } from "react";

/**
 * VideoHero — full-bleed autoplay background video, landscape-cover fit.
 *  - muted + loop + playsInline so autoplay works on all major browsers
 *  - Minimal contrast overlay so the source video stays crisp
 *  - Falls back to children (e.g. PhotonicHero SVG) if the video fails to load
 */
export default function VideoHero({ src, poster, children }) {
    const videoRef = useRef(null);
    const [failed, setFailed] = useState(false);

    if (failed) return children || null;

    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-testid="video-hero">
            <video
                ref={videoRef}
                src={src}
                poster={poster}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onError={() => setFailed(true)}
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full min-w-full min-h-full object-cover"
                style={{ background: "#050510" }}
            />
            {/* Minimal left-side vignette — just enough to anchor the headline on busy frames.
                Right side stays fully transparent so the video reads at its full quality. */}
            <div
                className="absolute inset-0"
                style={{
                    background:
                        "linear-gradient(90deg, rgba(5,5,16,0.55) 0%, rgba(5,5,16,0.25) 40%, rgba(5,5,16,0) 70%)",
                }}
            />
            {/* Soft bottom fade so the hero transitions cleanly into the page below */}
            <div
                className="absolute bottom-0 inset-x-0 h-40"
                style={{ background: "linear-gradient(180deg, transparent, #050510)" }}
            />
        </div>
    );
}
